import { ArrowRightGlobalNavigation } from 'src/components/icons/ArrowRightGlobalNavigation'
import Logo from '../../../Common/Logo'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { hasNextLevel } from '../../../utils'

export const WithLogo = ({ item }: ParentAndLinkItemProps) => {
  return (
    <div
      className="p-1 flex flex-row gap-3 items-center justify-between mb-1 navigation-link-panel"
      data-category="small-animals"
      data-step="2"
      data-tab={`data-${item.label}`}
    >
      <div className="flex flex-row gap-2 items-center">
        <Logo logo={item.logoImage ?? ''} label={item.label ?? ''} />
        <div>
          <span className="block text-sm font-semibold tracking-[0.035px] text-[#232323]">
            {item.label}
          </span>
        </div>
      </div>
      {hasNextLevel(item) && (
        <span className="block w-6 h-6">
          <ArrowRightGlobalNavigation />
        </span>
      )}
    </div>
  )
}
